/*
 * Copyright (c) 2026 Talent Catalog.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License
 * for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see https://www.gnu.org/licenses/.
 */

import {Component, OnInit} from '@angular/core';
import {VisaEligibility} from "../../../../../model/candidate";
import {EnumOption, enumOptions} from "../../../../../util/enum";
import {UntypedFormBuilder} from "@angular/forms";
import {VisaCheckComponentBase} from "../../../../util/intake/VisaCheckComponentBase";
import {CandidateVisaCheckService} from "../../../../../services/candidate-visa-check.service";

@Component({
  selector: 'app-visa-job-put-forward',
  templateUrl: './visa-job-put-forward.component.html',
  styleUrls: ['./visa-job-put-forward.component.scss']
})
export class VisaJobPutForwardComponent extends VisaCheckComponentBase implements OnInit {
  //Drop down values for enumeration
  visaEligibilityOptions: EnumOption[] = enumOptions(VisaEligibility);

  constructor(fb: UntypedFormBuilder, candidateVisaCheckService: CandidateVisaCheckService) {
    super(fb, candidateVisaCheckService);
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      visaJobId: [this.visaJobCheck?.id],
      visaJobPutForward: [this.visaJobCheck?.putForward],
    });
  }

}
